import { get, post } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const leadScoringService = {
  /**
   * Score and qualify a specific lead
   */
  scoreAndQualifyLead: async (leadId) => {
    try {
      const response = await post(`${API_ENDPOINTS.CRM.LEADS}/${leadId}/score`, {});

      if (response && response.responseCode === 200) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to score and qualify lead'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to score and qualify lead'
      };
    }
  },

  /**
   * Qualify a lead only (without recalculating score)
   */
  qualifyLeadOnly: async (leadId) => {
    try {
      const response = await post(`${API_ENDPOINTS.CRM.LEADS}/${leadId}/qualify`, {});

      if (response && response.responseCode === 200) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to qualify lead'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to qualify lead'
      };
    }
  },

  /**
   * Recalculate scores for all leads
   * COMMENTED OUT: Feature temporarily disabled
   */
  // recalculateAllLeadScores: async () => {
  //   try {
  //     const response = await post(API_ENDPOINTS.CRM.RECALCULATE_SCORES, {});

  //     if (response && response.responseCode === 200) {
  //       return {
  //         success: true,
  //         data: response.data
  //       };
  //     } else {
  //       return {
  //         success: false,
  //         error: response.responseMessage || 'Failed to recalculate lead scores'
  //       };
  //     }
  //   } catch (error) {
  //     return {
  //       success: false,
  //       error: error.message || 'Failed to recalculate lead scores'
  //     };
  //   }
  // },

  /**
   * Get lead scores with breakdown
   */
  getLeadScores: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.search) queryParams.append('search', filters.search);
      if (filters.scoreLabel && filters.scoreLabel !== 'all') queryParams.append('scoreLabel', filters.scoreLabel);
      if (filters.isQualified !== undefined) queryParams.append('isQualified', filters.isQualified);
      if (filters.page) queryParams.append('page', filters.page);
      if (filters.limit) queryParams.append('limit', filters.limit);

      const url = queryParams.toString()
        ? `${API_ENDPOINTS.CRM.LEAD_SCORES}?${queryParams.toString()}`
        : API_ENDPOINTS.CRM.LEAD_SCORES;

      const response = await get(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          leads: response.data?.leads || [],
          pagination: response.data?.pagination || {}
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve lead scores',
          leads: [],
          pagination: {}
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to retrieve lead scores',
        leads: [],
        pagination: {}
      };
    }
  }
};

export default leadScoringService;

